<fast-ui-game-menu
  [availableGames]="availableGames$ | async"
  [state]="(statuses$ | async)!"
  [isShowFullView]="gameSelectorOpened$ | async"
  [online]="online$ | async"
  (toggleFullView)="toggleFullView($event)"
></fast-ui-game-menu>
